import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import { ChevronRightIcon } from "@tencent/tea-icons-react";
import { DropdownBox } from "../dropdown";
import { useConfig } from "../_util/config-context";
import { noop } from "../_util/noop";
import { isMobile } from "../_util/is-mobile";
import { useOutsideClick } from "../_util/use-outside-click";
import { mergeRefs } from "../util";
import { Popover } from "../popover";
import { ListItemButton } from "./ListItemButton";
import { ListItemContent } from "./ListItemContent";
import { useListContext } from "./List";
export var ListSubMenu = React.forwardRef(function ListSubMenu(_a, ref) {
    var label = _a.label, children = _a.children, _b = _a.placement, placement = _b === void 0 ? "right-start" : _b, _c = _a.trigger, trigger = _c === void 0 ? "hover" : _c, className = _a.className, disabled = _a.disabled, visible = _a.visible, current = _a.current, selected = _a.selected, _d = _a.onVisibleChange, onVisibleChange = _d === void 0 ? noop : _d, _e = _a.onMouseEnter, onMouseEnter = _e === void 0 ? noop : _e, _f = _a.onMouseLeave, onMouseLeave = _f === void 0 ? noop : _f, _g = _a.onClick, onClick = _g === void 0 ? noop : _g, props = __rest(_a, ["label", "children", "placement", "trigger", "className", "disabled", "visible", "current", "selected", "onVisibleChange", "onMouseEnter", "onMouseLeave", "onClick"]);
    var classPrefix = useConfig().classPrefix;
    var liRef = useRef(null);
    var enterTimerRef = useRef(null);
    var leaveTimerRef = useRef(null);
    var type = useListContext().type;
    var _h = __read(useState(false), 2), hover = _h[0], setHover = _h[1];
    var _j = __read(useState(visible), 2), subMenuVisible = _j[0], setSubMenuVisible = _j[1];
    var listen = useOutsideClick(liRef).listen;
    useEffect(function () {
        return function () {
            clearTimeout(enterTimerRef.current);
            clearTimeout(leaveTimerRef.current);
        };
    }, []);
    if (disabled) {
        return (React.createElement("li", __assign({}, props, { className: classNames(classPrefix + "-list__submenu", "is-disabled", className, {
                "is-current": current,
                "is-selected": selected,
            }) }), type === "plain" ? (React.createElement(React.Fragment, null,
            React.createElement(ListItemButton, null,
                React.createElement(ListItemContent, null, label),
                React.createElement(ChevronRightIcon, null)))) : (React.createElement(React.Fragment, null,
            label,
            React.createElement(ChevronRightIcon, null)))));
    }
    var triggerProps = isMobile || trigger === "click"
        ? {
            onClick: function (event) {
                onClick(event);
                onVisibleChange(true);
                setHover(true);
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
        }
        : {
            onClick: onClick,
            onMouseEnter: function (event) {
                onMouseEnter(event);
                clearTimeout(enterTimerRef.current);
                leaveTimerRef.current = setTimeout(function () {
                    onVisibleChange(true);
                    setHover(true);
                }, 150);
            },
            onMouseLeave: function (event) {
                onMouseLeave(event);
                clearTimeout(leaveTimerRef.current);
                enterTimerRef.current = setTimeout(function () {
                    onVisibleChange(false);
                    setHover(false);
                }, 150);
            },
        };
    if (isMobile || trigger === "click") {
        listen(function () {
            onVisibleChange(false);
            setHover(false);
        });
    }
    return (React.createElement(Popover, { placementOffset: 0, trigger: trigger, placement: placement, overlay: React.createElement(DropdownBox, null, children), defaultVisible: subMenuVisible, onVisibleChange: function (v) {
            onVisibleChange(v);
            setSubMenuVisible(v);
        }, popupContainer: liRef.current },
        React.createElement("li", __assign({ ref: mergeRefs(ref, liRef) }, props, { className: classNames(classPrefix + "-list__submenu", className, {
                "is-hover": hover || subMenuVisible,
                "is-current": current,
                "is-selected": selected,
            }) }, triggerProps), type === "plain" ? (React.createElement(React.Fragment, null,
            React.createElement(ListItemButton, null,
                React.createElement(ListItemContent, null, label),
                React.createElement(ChevronRightIcon, null)))) : (React.createElement(React.Fragment, null,
            label,
            React.createElement(ChevronRightIcon, null))))));
});
ListSubMenu.displayName = "ListSubMenu";
//# sourceMappingURL=ListSubMenu.js.map